import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
    name: "login",
    initialState: () => {
        const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'));
        const lastLoginTime = JSON.parse(localStorage.getItem('jtg-caiwu_lastLoginTime'));
        
        // Check if login has expired (24 hours)
        const isExpired = lastLoginTime && (Date.now() - lastLoginTime) > 24 * 60 * 60 * 1000;
        
        if (!yh_id || isExpired) {
            // Clear all auth-related localStorage if expired
            if (isExpired) {
                localStorage.removeItem('jtg-caiwu_yh_id');
                localStorage.removeItem('jtg-caiwu_yh_phone');
                localStorage.removeItem('jtg-caiwu_qy_id');
                localStorage.removeItem('jtg-caiwu_qy_name');
                localStorage.removeItem('jtg-caiwu_yh_name');
                localStorage.removeItem('jtg-caiwu_yh_qx');
                localStorage.removeItem('jtg-caiwu_dd_eowg_id');
                localStorage.removeItem('jtg-caiwu_dd_eowg_name');
                localStorage.removeItem('jtg-caiwu_dd_dq_date');
                localStorage.removeItem('jtg-caiwu_dd_xf_num');
                localStorage.removeItem('jtg-caiwu_lastLoginTime');
                localStorage.removeItem('jtg-caiwu_yh_juese');
            }
            
            return {
                isLog: false,
                yh_id: null,
                yh_phone: null,
                qy_id: null,
                qy_name: null,  
                yh_name: null,  
                yh_qx: null,  
                dd_eowg_id: null,
                dd_eowg_name: null,
                dd_dq_date: null,
                dd_xf_num: null,
                yh_juese: null,
            }
        }
        
        return {
            isLog: true,
            yh_id: JSON.parse(localStorage.getItem('jtg-caiwu_yh_id')),
            yh_phone: JSON.parse(localStorage.getItem('jtg-caiwu_yh_phone')),
            qy_id: JSON.parse(localStorage.getItem('jtg-caiwu_qy_id')),
            qy_name: JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')),            
            yh_juese: JSON.parse(localStorage.getItem('jtg-caiwu_yh_juese')),            
            yh_name: JSON.parse(localStorage.getItem('jtg-caiwu_yh_name')),            
            yh_qx: JSON.parse(localStorage.getItem('jtg-caiwu_yh_qx')),            
            dd_eowg_id: JSON.parse(localStorage.getItem('jtg-caiwu_dd_eowg_id')),            
            dd_eowg_name: JSON.parse(localStorage.getItem('jtg-caiwu_dd_eowg_name')),            
            dd_dq_date: JSON.parse(localStorage.getItem('jtg-caiwu_dd_dq_date')),            
            dd_xf_num: JSON.parse(localStorage.getItem('jtg-caiwu_dd_xf_num')),            
        }
    },
    reducers: {
        setLogin(state, action) {
            state.isLog = true;
            state.yh_id = action.payload.yh_id;
            state.yh_phone = action.payload.yh_phone;
            state.qy_id = action.payload.qy_id;
            state.qy_name = action.payload.qy_name;      
            state.yh_name = action.payload.yh_name;      
            state.yh_juese = action.payload.yh_juese || null;      
            state.yh_qx = action.payload.yh_qx;      
            state.dd_eowg_id = action.payload.dd_eowg_id;      
            state.dd_eowg_name = action.payload.dd_eowg_name;      
            state.dd_dq_date = action.payload.dd_dq_date;      
            state.dd_xf_num = action.payload.dd_xf_num;      
            
            // Save to localStorage
            localStorage.setItem('jtg-caiwu_yh_id', JSON.stringify(state.yh_id));
            localStorage.setItem('jtg-caiwu_yh_phone', JSON.stringify(state.yh_phone));
            localStorage.setItem('jtg-caiwu_qy_id', JSON.stringify(state.qy_id));
            localStorage.setItem('jtg-caiwu_qy_name', JSON.stringify(state.qy_name));           
            localStorage.setItem('jtg-caiwu_yh_juese', JSON.stringify(state.yh_juese));           
            localStorage.setItem('jtg-caiwu_yh_name', JSON.stringify(state.yh_name));           
            localStorage.setItem('jtg-caiwu_yh_qx', JSON.stringify(state.yh_qx));           
            localStorage.setItem('jtg-caiwu_dd_eowg_id', JSON.stringify(state.dd_eowg_id));           
            localStorage.setItem('jtg-caiwu_dd_eowg_name', JSON.stringify(state.dd_eowg_name));           
            localStorage.setItem('jtg-caiwu_dd_dq_date', JSON.stringify(state.dd_dq_date));           
            localStorage.setItem('jtg-caiwu_dd_xf_num', JSON.stringify(state.dd_xf_num));
            
            // Store the current time as last login time
            localStorage.setItem('jtg-caiwu_lastLoginTime', JSON.stringify(Date.now()));
        },
        setLogout(state, action) {
            state.isLog = false;
            if (!state.isRemeberUser) {
                localStorage.removeItem('jtg-caiwu_yh_id');
                localStorage.removeItem('jtg-caiwu_yh_phone');
                localStorage.removeItem('jtg-caiwu_qy_id');                
                localStorage.removeItem('jtg-caiwu_qy_name');              
                localStorage.removeItem('jtg-caiwu_yh_juese');              
                localStorage.removeItem('jtg-caiwu_yh_name');              
                localStorage.removeItem('jtg-caiwu_yh_qx');              
                localStorage.removeItem('jtg-caiwu_mainTagActive');              
                localStorage.removeItem('jtg-caiwu_dd_eowg_id');              
                localStorage.removeItem('jtg-caiwu_dd_eowg_name');              
                localStorage.removeItem('jtg-caiwu_dd_dq_date');              
                localStorage.removeItem('jtg-caiwu_jtg-caiwu_ysyf_id');              
                localStorage.removeItem('jtg-caiwu_jtg-caiwu_dsbzd_id');              
                localStorage.removeItem('jtg-caiwu_mainTag');              
                localStorage.removeItem('jtg-caiwu_dd_xf_num');
                localStorage.removeItem('jtg-caiwu_lastLoginTime');
            }
        },
        checkLoginExpiration(state) {
            const lastLoginTime = JSON.parse(localStorage.getItem('jtg-caiwu_lastLoginTime'));
            const isExpired = lastLoginTime && (Date.now() - lastLoginTime) > 24 * 60 * 60 * 1000;
            
            if (isExpired) {
                state.isLog = false;
                state.yh_id = null;
                state.yh_phone = null;
                state.qy_id = null;
                state.qy_name = null;
                state.yh_name = null;
                state.yh_juese = null;
                state.yh_qx = null;
                state.dd_eowg_id = null;
                state.dd_eowg_name = null;
                state.dd_dq_date = null;
                state.dd_xf_num = null;
                
                // Clear all auth-related localStorage
                localStorage.removeItem('jtg-caiwu_yh_id');
                localStorage.removeItem('jtg-caiwu_yh_phone');
                localStorage.removeItem('jtg-caiwu_qy_id');
                localStorage.removeItem('jtg-caiwu_qy_name');
                localStorage.removeItem('jtg-caiwu_yh_name');
                localStorage.removeItem('jtg-caiwu_yh_qx');
                localStorage.removeItem('jtg-caiwu_dd_eowg_id');
                localStorage.removeItem('jtg-caiwu_dd_eowg_name');
                localStorage.removeItem('jtg-caiwu_dd_dq_date');
                localStorage.removeItem('jtg-caiwu_dd_xf_num');
                localStorage.removeItem('jtg-caiwu_yh_juese');
                localStorage.removeItem('jtg-caiwu_lastLoginTime');
            }
        }
    }
})

export const { setLogin, setLogout, checkLoginExpiration } = loginSlice.actions;
export const { reducer: loginReducer } = loginSlice;